import { v1 as uuid } from 'uuid';
import i18n from 'i18next';

export const ADD_TOAST = 'ADD_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';

const defaultErrorMessages = {
  GET: i18n.t('toasts.errorDefault.get', { ns: ['actions'] }),
  POST: i18n.t('toasts.errorDefault.post', { ns: ['actions'] }),
  PUT: i18n.t('toasts.errorDefault.put', { ns: ['actions'] }),
  DELETE: i18n.t('toasts.errorDefault.delete', { ns: ['actions'] }),
  expiredToken: i18n.t('toasts.errorDefault.expiredToken', { ns: ['actions'] }),
  defaultMessage: i18n.t('toasts.errorDefault.defaultMessage', {
    ns: 'actions'
  })
};

export const getServerIdFromMessage = payload => {
  let id;

  try {
    id = (JSON.parse(payload?.response?.data?.message) || {}).id;
  } catch (e) {
    id = undefined;
  }

  return id;
};

export const createToast = (options, payload) => {
  let customMessage;
  const method = options?.method || payload?.response?.config?.method;

  if (payload?.response?.data?.statusCode === 401) {
    customMessage = options?.defaultMessage || defaultErrorMessages.expiredToken;
  } else {
    customMessage =
      options?.defaultMessage || (method ? defaultErrorMessages[method] : defaultErrorMessages.defaultMessage);
  }

  const serverResponseId = options.type === 'error' && getServerIdFromMessage(payload);
  return {
    ...options,
    defaultMessage: customMessage,
    serverResponseId,
    id: uuid()
  };
};

export const addToast = (options, payload) => ({
  type: ADD_TOAST,
  toast: createToast(options, payload)
});

export const removeToast = toastId => ({
  toastId,
  type: REMOVE_TOAST
});
